import { Action, createReducer, on } from '@ngrx/store';
import { ICheckRegisterRequiredRequest, ICheckRegisterRequiredResponse } from '../../../core/models/check-registration.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import {
  checkRegisterRequiredSuccess,
  checkRegisterRequiredFailure,
  checkRegisterRequiredRequest
} from '../actions/check-if-registered.actions';

export const checkIfRegisteredFeatureKey = 'checkIfRegistered';

export interface CheckRegistrationState {
  isLoading: boolean;
  checkRegistrationRequest: ICheckRegisterRequiredRequest;
  checkRegistrationSuccess: ICheckRegisterRequiredResponse;
  checkRegistrationFailure: IGenericError<ErrorResponse>;
}

export const initialState: CheckRegistrationState = {
  isLoading: false,
  checkRegistrationRequest: undefined,
  checkRegistrationSuccess: undefined,
  checkRegistrationFailure: undefined
};

export const reducer = createReducer(
  initialState,

  //#region Validate
  on(checkRegisterRequiredRequest, (state, action) => ({
    ...state,
    checkRegistrationRequest: action.request,
    isLoading: true
  })),
  on(checkRegisterRequiredSuccess, (state, action) => ({
    ...state,
    checkRegistrationSuccess: action.response,
    isLoading: false
  })),
  on(checkRegisterRequiredFailure, (state, action) => ({
    ...state,
    checkRegistrationFailure: action.error,
    isLoading: false
  }))
  //#endregion
);

//#region Validate
export const checkRegisterRequiredRequestLoading = (state: CheckRegistrationState) => state.isLoading;
export const getCheckRegisterRequiredRequest = (state: CheckRegistrationState) => state.checkRegistrationRequest;
export const checkRegisterRequiredRequestSuccess = (state: CheckRegistrationState) => state.checkRegistrationSuccess;
export const checkRegisterRequiredRequestFailure = (state: CheckRegistrationState) => state.checkRegistrationFailure;

//#endregion
